import { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { useMe, logout } from '../api'
import { isActivePath, navItems } from './nav/items'
import { WhatsNewModal } from './WhatsNewModal'

export function Sidebar() {
  const location = useLocation()
  const { data: me } = useMe()
  const [whatsNewOpen, setWhatsNewOpen] = useState(false)
  const isAdmin = me?.role === 'admin'

  return (
    <aside className="hidden md:flex flex-col w-60 border-r border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 shrink-0">
      {/* Logo */}
      <div className="px-5 py-5 border-b border-gray-100 dark:border-gray-800">
        <h1 className="text-lg font-semibold text-gray-900 dark:text-gray-100">МММ</h1>
      </div>

      {/* Navigation */}
      <nav className="flex-1 px-3 py-4 space-y-1">
        {navItems.filter(item => !item.adminOnly || isAdmin).map(item => (
          <Link
            key={item.path}
            to={item.path}
            className={`flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${
              isActivePath(location.pathname, item.path)
                ? 'bg-blue-50 dark:bg-blue-950/30 text-blue-600 dark:text-blue-400'
                : 'text-gray-600 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-800 hover:text-gray-900 dark:hover:text-gray-200'
            }`}
          >
            {item.icon}
            {item.label}
          </Link>
        ))}
      </nav>

      {/* User info + logout */}
      <div className="px-5 py-4 border-t border-gray-100 dark:border-gray-800">
        {me && (
          <p className="text-xs text-gray-500 dark:text-gray-400 truncate mb-2">
            {me.email}
          </p>
        )}
        {isAdmin ? (
          <>
            <button
              type="button"
              onClick={() => setWhatsNewOpen(true)}
              className="block text-left text-[10px] text-gray-400 dark:text-gray-600 tabular-nums hover:text-blue-600 dark:hover:text-blue-400 transition-colors cursor-pointer mb-3"
              aria-label="What's new"
            >
              v{__APP_VERSION__} · what's new
            </button>
            <WhatsNewModal
              open={whatsNewOpen}
              onClose={() => setWhatsNewOpen(false)}
            />
          </>
        ) : (
          <p className="text-[10px] text-gray-400 dark:text-gray-600 tabular-nums mb-3">
            v{__APP_VERSION__}
          </p>
        )}
        <button
          onClick={() => logout()}
          className="block text-sm text-gray-500 hover:text-gray-700 dark:hover:text-gray-300 transition-colors"
        >
          Logout
        </button>
      </div>
    </aside>
  )
}
